module.exports = __webpack_public_path__ + "static/media/viatris.95f64d64.png";